// extracted by mini-css-extract-plugin
export default {"loader":"_G_imIPsjHOt9nyng5_B"};